(function($) {
    const endorsementRequestApproval = () => {
        const $request = $('.endorsement-request-review')

        $request.each(function() {
            const $approveBtn = $(this).find('.btn-approve')
            const $rejectBtn = $(this).find('.btn-reject')
            const requestId = $(this).data('request-id')
            const $notifyBtn = $(this).find('.btn-notify')

            $approveBtn.on('click', function() {
                updateItem('update', requestId, 'approved', $(this))
            })
            $rejectBtn.on('click', function() {
                updateItem('update', requestId, 'rejected', $(this))
            })
            $notifyBtn.on('click', function() {
                notifyCandidate(requestId, $(this))
            })
        })

    }

    function updateItem(type, id, action, $button) {
        fetch('/wp-json/endorsement-request/v1/update/' + id, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-WP-Nonce': wpApiSettings.nonce
            },
            body: JSON.stringify({
                moderation_status: action
            })
        })
            .then(response => response.json())
            .then(data => {
                console.log(data)
                if (data.success) {
                    (action === 'approved') ? $button.parent().find('.btn-reject').remove() : $button.parent().find('.btn-approve').remove()
                }
                $button.addClass('btn-message')
                $button.css('width', 'auto')
                $button.find('span').text(data.message)
                setTimeout(() => {
                    $button.closest('.moderate-candidate').fadeOut(function() {$(this).remove()})
                  }, 2500);
            })
            .catch(error => {
                console.error('Error:', error);
            });
    }

    function notifyCandidate(request_id, $button) {
        var data = {
            request_id: request_id
        };
        $.ajax({
            url: '/send-endorsement-request-notification',
            method: 'POST',
            data: data,
            success: function (data) {
                if (data === 'success') {
                    $button.find('span').text('Notification Sent')
                    $button.addClass('btn-message')
                    setTimeout(() => {
                        $button.closest('.moderate-candidate').fadeOut(function() {$(this).remove()})
                    }, 2500);
                }
            },
            error: function (jqXHR) {
                console.error('Error marking notification as read:', jqXHR);
            }
        });
    }

    $(function() {
        endorsementRequestApproval()
    })
})(jQuery);
